<template>
  <div>
    <!-- Analisys IN_PROGRESS -->
    <v-progress-circular
      v-if="row.analyze_status === 'IN_PROGRESS'"
      indeterminate
      color="primary"
    ></v-progress-circular>

    <!-- Analisys SUCCEEDED -->
    <template
      v-else-if="row.prodAnalysis || row.stageAnalysis || row.playAnalysis"
    >
      <!-- Analisys PROD -->
      <v-tooltip bottom color="white" v-if="row.prodAnalysis">
        <template v-slot:activator="{ on }">
          <v-chip
            class="ma-2"
            :color="row.prodAnalysis.error ? 'error' : 'success'"
            v-on="on"
          >
            <v-icon v-if="row.prodAnalysis.error" left>mdi-close</v-icon>
            <v-icon v-else left>mdi-checkbox-marked-circle</v-icon>
            production
          </v-chip>
        </template>
        <span v-if="row.prodAnalysis.error" class="red--text">
          {{ row.prodAnalysis.error.exceptionMessage }}
        </span>
        <span v-else class="black--text">
          This item is analyzed on the Prod environment.
        </span>
      </v-tooltip>

      <!-- Analisys STAGE -->
      <v-tooltip bottom color="white" v-if="row.stageAnalysis">
        <template v-slot:activator="{ on }">
          <v-chip
            class="ma-2"
            :color="row.stageAnalysis.error ? 'error' : 'success'"
            v-on="on"
          >
            <v-icon v-if="row.stageAnalysis.error" left>mdi-close</v-icon>
            <v-icon v-else left>mdi-checkbox-marked-circle</v-icon>
            stage
          </v-chip>
        </template>
        <span v-if="row.stageAnalysis.error" class="red--text">
          {{ row.stageAnalysis.error.exceptionMessage }}
        </span>
        <span v-else class="black--text">
          This item is analyzed on the Stage environment.
        </span>
      </v-tooltip>

      <!-- Analisys PLAY -->
      <v-tooltip bottom color="white" v-if="row.playAnalysis">
        <template v-slot:activator="{ on }">
          <v-chip
            class="ma-2"
            :color="row.playAnalysis.error ? 'error' : 'success'"
            v-on="on"
          >
            <v-icon v-if="row.playAnalysis.error" left>mdi-close</v-icon>
            <v-icon v-else left>mdi-checkbox-marked-circle</v-icon>
            play
          </v-chip>
        </template>
        <span v-if="row.playAnalysis.error" class="red--text">
          {{ row.playAnalysis.error.exceptionMessage }}
        </span>
        <span v-else class="black--text">
          This item is analyzed on the Play environment.
        </span>
      </v-tooltip>
    </template>
    <v-tooltip bottom color="white" v-else>
      <template v-slot:activator="{ on }">
        <v-icon v-on="on">mdi-close</v-icon>
      </template>
      <span class="black--text">Hasn't analysed yet</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    row: {
      type: Object,
      default: () => ({
        analyze_status: null,
        import_status: null
      })
    }
  },
  methods: {}
};
</script>
